import { Component, OnInit } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subject } from 'rxjs';
import { ListingsService } from '../../service/listings.service';
import { takeUntil } from 'rxjs/operators';
import { NotifyService } from 'src/app/core/layouts/notifications/notify/notify.service';

@Component({
  selector: 'listing-details',
  templateUrl: './listing-details.component.html',
  styleUrls: ['./listing-details.component.scss'],
})

export class ListingDetailsComponent implements OnInit {
  private ngUnsubscribe$ = new Subject();
  public selListing: any;
  public selMatch: any;
  public listingMatches: any[] = [];

  public isLoadingData: boolean = false;

  constructor(
    private dynamicDialogConfig: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private listingsService: ListingsService,
    private notifyService: NotifyService,
  ) {}

  ngOnInit(): void {
    this.selListing = this.dynamicDialogConfig.data.listing;
    this.getListingMatches();
  }

  private getListingMatches(): void {
    this.isLoadingData = true;
    const { accountId, userId } = this.dynamicDialogConfig.data;
    const listingId = this.selListing.listing_id;

    this.listingsService.loadListingMatches(accountId, userId, listingId)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe({
        next: (response) => {
          this.listingMatches = response.matches || [];
          this.isLoadingData = false;
        },
        error: (error) => {
          console.error('Error loading listing matches:', error);
          this.notifyService.error('Error while loading listing matches.');
          this.isLoadingData = false;
        }
      });
  }

  public generateMatches(): void {
    this.isLoadingData = true;
    const { accountId, userId } = this.dynamicDialogConfig.data;
    const listingId = this.selListing.listing_id;
    this.listingsService.generateListingMatches(accountId, userId, listingId)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe({
        next: (response) => {
          this.listingMatches = response.matches || [];
          this.isLoadingData = false;
        },
        error: (error) => {
          console.error('Error generating matches:', error);
          this.notifyService.error('Error while generating matches.');
          this.isLoadingData = false;
        }
      });
  }

  public saveSelection(): void {
    this.isLoadingData = true;
    const { accountId, userId } = this.dynamicDialogConfig.data;
    const listingId = this.selListing.listing_id;
    const matchId = this.selMatch.match_id;
    this.listingsService.saveSelectedMatch(accountId, userId, listingId, matchId)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe({
        next: (response) => {
          this.selListing.match_status = 'pending';
          this.isLoadingData = false;

          this.listingMatches = this.listingMatches.map(match => ({
            ...match,
            match_status: match.match_id === matchId ? 'selected' : 'not selected'
          }));
        },
        error: (error) => {
          console.error('Error selecting match:', error);
          this.notifyService.error('Error while saving match selection.');
          this.isLoadingData = false;
        }
      });
  }

  public createListing(): void {
    this.isLoadingData = true;
    const { accountId, userId } = this.dynamicDialogConfig.data;
    const listingId = this.selListing.listing_id;

    this.listingsService.createListing(accountId, userId, listingId)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe({
        next: (response) => {
          this.selListing.match_status = 'creating';
          this.isLoadingData = false;
        },
        error: (error) => {
          console.error('Error creating listing:', error);
          this.notifyService.error('Error while creating listing.');
          this.isLoadingData = false;
        }
      });
  }

  getJoinedAddress(address: (string | null)[]): string {
    return address?.filter((a) => !!a).join(', ') ?? '';
  }

  toTitleCase(str: string): string {
    return str
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
}
